<template>
  <div class="mt-4">
    <h3>Lesson Schedules</h3>
    <v-data-table class="mt-2" :headers="headers" :items="lessons" @click:row="showLesson" />
  </div>
</template>

<script>
export default {
  props: ['lessons'],

  data() {
    return {
      headers: [
        { text: 'name', value: 'name' },
        { text: 'description', value: 'description' },
        { text: 'start_at (GMT)', value: 'start_at' },
        { text: 'end_at (GMT)', value: 'end_at' },
      ],
    };
  },

  methods: {
    showLesson(lesson) {
      this.$router.push({
        name: 'study-program.admin.lessons',
        params: { groupId: lesson.study_group_id, lessonId: lesson.id },
      });
    },
  },
};
</script>
